export default __webpack_public_path__ + "static/media/laundry2-after-1440w.beb06c36.png";